export class PollingManager {
  constructor(apiUrl, itemId, updateCallback, finishedCallback) {
    this.apiUrl = apiUrl;
    this.itemId = itemId;
    this.updateCallback = updateCallback;
    this.finishedCallback = finishedCallback;
    this.pollInterval = null;
    this.attempts = 0;
  }

  async startPolling() {
    console.log("Started polling actions every 5s");
    await this.poll();
    this.pollInterval = setInterval(async () => {
      await this.poll();
    }, 5000);
  }

  stopPolling() {
    clearInterval(this.pollInterval);
    console.log("Stopped polling actions");
    this.finishedCallback(true);
  }

  async poll() {
    this.attempts++;
    let done = false;
    try {
      const request = new Request(this.apiUrl, {
        method: "POST",
        body: JSON.stringify({ "item_id": this.itemId })
      });
      const response = await fetch(request);
      const data = await response.json();
      this.updateCallback(data);
    } catch (error) {
      console.error('Polling actions error:', error);
    } finally {
      if (done === true || this.attempts > 12) {
        this.stopPolling();
        return;
      }
    }
  }
}
